import { useState } from 'react';
import { Typography, Button, Paper, Box } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import verifyOtpPageStyles from '../../../styles/PublicPage/verifyotppage';
import { introductionPageStyles } from '../../../styles/ProtectedPage/introduction';
import { PATH_NAME } from '../../../configs/pathName';
import colorConfigs from '../../../configs/colorConfigs';
import { typo } from '../../../assets/fonts/font';
import logo from '../../../assets/images/nomzy_logo.png';
import assets from '../../../assets';
import Step from '../../../assets/index';

const IntroductionPage = () => {
  const [step, setStep] = useState(1);
  const navigate = useNavigate();
  const totalSteps = 5;

  const handleNext = () => {
    if (step < totalSteps) {
      setStep(step + 1);
    } else {
      navigate(PATH_NAME.MEMBER);
    }
  };

  const handleBack = () => {
    if (step > 1) {
      setStep(step - 1);
    } else {
      navigate(PATH_NAME.ROOT);
    }
  };

  return (
    <Paper elevation={1} sx={introductionPageStyles.rootPaper}>
      <Box sx={introductionPageStyles.headerBox}>
        <Box>
          <img
            alt="Company Logo"
            src={assets.images.logo}
            style={verifyOtpPageStyles.logoImage}
          />
        </Box>
      </Box>
      <Box sx={introductionPageStyles.contentBox}>
        {step === 1 && (
          <>
            <Typography
              sx={{ ...typo.smallText, color: colorConfigs.tertiary, fontSize: '16px', mb: 1 }}
            >
              Introducing
            </Typography>
            <Box sx={{ display: 'flex', flexDirection: 'row', alignItems: 'center' }}>
              <Box sx={{ flex: 1 }}>
                <img
                  src={logo}
                  alt="Introducing"
                  style={{ width: '85%', maxWidth: '250px' }}
                />
              </Box>
              <Box sx={{ flex: 1 }}>
                <Typography sx={{ ...typo.title, fontSize: '26px' }}>Smart Fridge</Typography>
              </Box>
            </Box>
            <Typography
              sx={{ ...typo.smallText, color: colorConfigs.tertiary, fontSize: '16px', mt: 1 }}
            >
              Your self-service smart fridge, anytime, everyday​  
            </Typography>
            <Box sx={{ mt: 2, textAlign: 'center' }}>
              <img
                src={Step.images.introducing}
                alt="introducing"
                style={{ width: '100%', maxWidth: '300px' }}
              />
            </Box>
            <Box sx={{ mt: 4, width: '100%' }}>
              <Button
                variant="contained"
                onClick={handleNext}
                sx={{
                  ...typo.button,
                  backgroundColor: colorConfigs.tertiary,
                  color: colorConfigs.secondary,
                  borderRadius: '30px',
                  width:{xs:'100%', sm:'30%'},
                  "&:hover": {
                    backgroundColor: colorConfigs.tertiary,
                  },
                  textTransform: 'none',
                }}
              >
                Let's Begin!
              </Button>
            </Box>
          </>
        )}
        {step === 2 && (
          <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, justifyContent: 'center', width: '100%' }}>
              <Box sx={{ textAlign: 'center', width: '100%', maxWidth: '300px' }}>
                <Typography sx={{ ...typo.title, color: colorConfigs.tertiary, fontSize: '22px' }} variant="h6">
                  1. Set-up your Account
                </Typography>
              </Box>
            </Box>
            <Box sx={{ height: '380px' }}>
              <Typography sx={{ ...typo.smallText, color: colorConfigs.tertiary, fontSize: '16px' }}>
                Link your credit card for fuss-free transactions or top-up $5.00 to your wallet using PayNow.​
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                <img
                  src={Step.images.step1Gif}
                  alt="Wallet Setup GIF"
                  style={{ width: '100%', maxWidth: '250px' }}
                />
              </Box>
              <Typography sx={{ textAlign: 'center', ...typo.smallText, color: colorConfigs.tertiary, fontSize: '16px' }}>
                For credit cards, there will be a pre-authorization charge of $0.01 that will be credited to your wallet. Subsequent purchases will automatically be deducted from the linked credit card.
              </Typography>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 2 }}>
              <Button
                variant="contained"
                onClick={handleBack}
                sx={{
                  backgroundColor: colorConfigs.tertiary,
                  '&:hover': { backgroundColor: colorConfigs.tertiary, color: colorConfigs.secondary },
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderRadius: '5px',
                  ...typo.button,
                  color: colorConfigs.secondary,
                  textTransform: 'none',
                }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                sx={{
                  backgroundColor: colorConfigs.primary,
                  '&:hover': { backgroundColor: colorConfigs.primaryHover, color: colorConfigs.secondary },
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderRadius: '5px',
                  ...typo.button,
                  color: colorConfigs.secondary,
                  textTransform: 'none',
                }}
              >
                Next
              </Button>
            </Box>
          </>
        )}
        {step === 3 && (
          <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, justifyContent: 'center', width: '100%' }}>
              <Box sx={{ textAlign: 'center', width: '100%', maxWidth: '300px' }}>
                <Typography sx={{ ...typo.title, color: colorConfigs.tertiary, fontSize: '22px' }} variant="h6">
                  2. Unlock the fridge​  
                </Typography>
              </Box>
            </Box>
            <Box sx={{ height: '380px' }}>
              <Typography sx={{ ...typo.smallText, color: colorConfigs.tertiary, fontSize: '16px' }}>
                Place the QR code (find it under ’Wallet’) against the scanner to unlock it!​
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                <img
                  src={Step.images.step2Gif}
                  alt="Wallet Setup GIF"
                  style={{ width: '100%', maxWidth: '250px' }}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 2 }}>
              <Button
                variant="contained"
                onClick={handleBack}
                sx={{
                  backgroundColor: colorConfigs.tertiary,
                  '&:hover': { backgroundColor: colorConfigs.tertiary, color: colorConfigs.secondary },
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderRadius: '5px',
                  ...typo.button,
                  color: colorConfigs.secondary,
                  textTransform: 'none',
                }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                sx={{
                  backgroundColor: colorConfigs.primary,
                  '&:hover': { backgroundColor: colorConfigs.primaryHover, color: colorConfigs.secondary },
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderRadius: '5px',
                  ...typo.button,
                  color: colorConfigs.secondary,
                  textTransform: 'none',
                }}
              >
                Next
              </Button>
            </Box>
          </>
        )}
        {step === 4 && (
          <>
            <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, justifyContent: 'center', width: '100%' }}>
              <Box sx={{ textAlign: 'center', width: '100%', maxWidth: '300px' }}>
                <Typography sx={{ ...typo.title, color: colorConfigs.tertiary, fontSize: '22px' }} variant="h6">
                  3. Add products to cart​​
                </Typography>
              </Box>
            </Box>
            <Box sx={{ height: '380px' }}>
              <Typography sx={{ ...typo.smallText, color: colorConfigs.tertiary, fontSize: '16px' }}>
                Scan each item’s barcode to add to cart​​
              </Typography>
              <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                <img
                  src={Step.images.step3Gif}
                  alt="Wallet Setup GIF"
                  style={{ width: '100%', maxWidth: '250px' }}
                />
              </Box>
            </Box>
            <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 2 }}>
              <Button
                variant="contained"
                onClick={handleBack}
                sx={{
                  backgroundColor: colorConfigs.tertiary,
                  '&:hover': { backgroundColor: colorConfigs.tertiary, color: colorConfigs.secondary },
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderRadius: '5px',
                  ...typo.button,
                  color: colorConfigs.secondary,
                  textTransform: 'none',
                }}
              >
                Back
              </Button>
              <Button
                variant="contained"
                onClick={handleNext}
                sx={{
                  backgroundColor: colorConfigs.primary,
                  '&:hover': { backgroundColor: colorConfigs.primaryHover, color: colorConfigs.secondary },
                  paddingLeft: 5,
                  paddingRight: 5,
                  borderRadius: '5px',
                  ...typo.button,
                  color: colorConfigs.secondary,
                  textTransform: 'none',
                }}
              >
                Next
              </Button>
            </Box>
          </>
        )}
        {step === 5 && (
            <>
                <Box sx={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: 2, justifyContent: 'center', width: '100%' }}>
                
                <Box sx={{
                    textAlign: 'center',
                    width: '100%',
                    maxWidth: '300px',
                }}>
                    <Typography sx={{ ...typo.title, color: colorConfigs.tertiary, fontSize: '22px' }} variant="h6">
                    4. Checkout & pay!​
                    </Typography>
                </Box>
                
                </Box>

                <Box sx={{ height: '380px', textAlign: 'center' }}>
                <Typography sx={{ ...typo.smallText, color: colorConfigs.tertiary, fontSize: '16px' }}>
                    Ready to make payment? Pay using your linked credit card, or your wallet balance!​ 
                </Typography>

                <Box sx={{ display: 'flex', justifyContent: 'center', mb: 2, mt: 2 }}>
                    <img
                    src={Step.images.step4Gif}
                    alt="Wallet Setup GIF"
                    style={{ width: '100%', maxWidth: '250px' }}
                    />
                </Box>
                </Box>

                <Box sx={{ display: 'flex', justifyContent: 'space-between', gap: 2, mt: 2 }}>
                <Button
                    variant="contained"
                    onClick={handleBack}
                    sx={{
                    backgroundColor: colorConfigs.tertiary,
                    '&:hover': { backgroundColor: colorConfigs.tertiary, color: colorConfigs.secondary },
                    paddingLeft: 5,
                    paddingRight: 5,
                    borderRadius: '5px',
                    ...typo.button,
                    color: colorConfigs.secondary,
                    textTransform: 'none',
                    }}
                >
                    Back
                </Button>

                <Button
                    variant="contained"
                    onClick={handleNext}
                    sx={{
                    backgroundColor: colorConfigs.primary,
                    '&:hover': { backgroundColor: colorConfigs.primaryHover, color: colorConfigs.secondary },
                    paddingLeft: 5,
                    paddingRight: 5,
                    borderRadius: '5px',
                    ...typo.button,
                    color: colorConfigs.secondary,
                    textTransform: 'none',
                    }}
                >
                    Finish
                </Button>
                </Box>
            </>
        )}
      </Box>
    </Paper>
  );
};

export default IntroductionPage;
